// this is Vuex module for system info (https://vuex.vuejs.org/)

import { LOAD_SYSTEM_VERSION, SET_SYSTEM_VERSION } from '../actions/systemInfo'
import axios from 'axios'

const state = {
    version: null
}

const mutations = {
    [SET_SYSTEM_VERSION]: (state, { version }) => {
        state.version = version
    }
}

const actions = {
    [LOAD_SYSTEM_VERSION]: ({ commit }) => {
        return axios.get('/api/version').then(result => {
            const version = result.data
            commit(SET_SYSTEM_VERSION, { version })
        }).catch(error => {
            console.warn(error, error.response)
            commit(SET_SYSTEM_VERSION, { version: 'Unknown version' })
        })
    }
}

export default {
    state,
    actions,
    mutations
}
